import React, { useState } from 'react';
import { RejectRatioChart, NumberOfRejectsChart, NumberOfRejectEventsChart } from './index';
import SubTabNav from '../common/SubTabNav';

interface RejectsChartContainerProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  className?: string;
  activeSubTab?: 'ratio' | 'rejects' | 'events';
  onActiveSubTabChange?: (tab: 'ratio' | 'rejects' | 'events') => void;
}

const RejectsChartContainer: React.FC<RejectsChartContainerProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  className = '',
  activeSubTab,
  onActiveSubTabChange
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<'ratio' | 'rejects' | 'events'>('ratio');
  
  // Use external state if provided, otherwise use internal state
  const activeTab = activeSubTab !== undefined ? activeSubTab : internalActiveTab;
  const setActiveTab = onActiveSubTabChange || setInternalActiveTab;

  const tabs = [
    { key: 'ratio', label: 'Reject Ratio' },
    { key: 'rejects', label: 'Number of Rejects' },
    { key: 'events', label: 'Number of Reject Events' }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Subtab navigation */}
      <SubTabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) => setActiveTab(tab as 'ratio' | 'rejects' | 'events')}
      />

      {/* Chart content based on active tab */}
      {activeTab === 'ratio' ? (
        <RejectRatioChart 
          machineSerialNo={machineSerialNo || ''}
          lineId={lineId}
          shifts={shifts || []}
        />
      ) : activeTab === 'rejects' ? (
        <NumberOfRejectsChart 
          machineSerialNo={machineSerialNo || ''}
          lineId={lineId}
          shifts={shifts || []}
        />
      ) : (
        <NumberOfRejectEventsChart 
          machineSerialNo={machineSerialNo || ''}
          lineId={lineId}
          shifts={shifts || []}
        />
      )}
    </div>
  );
};

export default RejectsChartContainer;
